<h2 mat-dialog-title>{{ 'leavePage' | i18nextCap }}</h2>
<mat-dialog-content>
  <span>{{ 'leavePageMessage' | i18nextCap }}</span>
</mat-dialog-content>
<div mat-dialog-actions align="end">
  <button mat-button color="primary" [mat-dialog-close]="false">
    {{ 'cancel' | i18nextCap }}
  </button>
  <button mat-flat-button color="warn" [mat-dialog-close]="true">
    {{ 'leave' | i18nextCap }}
  </button>
</div>
